import React, { createContext, useContext, useMemo } from 'react';

import { Configuration, DashboardApi } from '@rtkwlf/insights';

import { useAuthContext } from '@packages/legacy/auth';
import { useOrganizationContext } from '@packages/legacy/organization-context';
import { env } from '@packages/utils/env';

const ApiContext = createContext<DashboardApi | null>(null);

const ERROR_MESSAGE =
  'useInsightsServiceApiContext hook must be used within an InsightsServiceAPIProvider.Provider; ensure your node is wrapped in one.';

export const useInsightsServiceApiContext = (): DashboardApi => {
  const ctx = useContext(ApiContext);
  if (ctx === null) {
    throw new Error(ERROR_MESSAGE);
  } else {
    return ctx;
  }
};

export const InsightsServiceAPIProvider = ({
  children,
}: React.PropsWithChildren) => {
  const { fetchApi } = useAuthContext();
  const { selectedOrganization } = useOrganizationContext();

  const url = env.VITE_INSIGHTS_BASE_PATH.replace(
    '{{pod}}',
    selectedOrganization.pod,
  );

  const api = useMemo(
    () =>
      new DashboardApi(
        new Configuration({
          basePath: url,
          fetchApi,
        }),
      ),
    [fetchApi, url],
  );

  return <ApiContext.Provider value={api}>{children}</ApiContext.Provider>;
};
